import styles from '@ui/components/Select/Select.module.scss';
import Content from '@ui/components/Content/Content';
import SelectRegular from '@ui/components/Select/components/SelectRegular';
import {
  FormDescription,
  FormError,
  FormField,
  Role,
  useSelectStore,
} from '@ariakit/react';
import React from 'react';

const SelectForm = ({
  store,
  hasOutline,
  hint,
  items,
  label,
  name,
  className,
  placeholder,
  required,
  multiple,
}) => {
  const defaultValue = store.useValue(name) || (multiple ? [] : '');

  const select = useSelectStore({
    defaultValue,
    setValue: value => store.setValue(name, value),
  });

  const selectElement = (
    <SelectRegular
      className={className}
      hasOutline={hasOutline}
      items={items}
      label={label}
      multiple={multiple}
      name={name}
      placeholder={placeholder}
      required={required}
      store={select}
    />
  );

  const formFieldElement = (
    <FormField name={name} render={selectElement} store={store} />
  );

  return (
    <>
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <Role.button render={formFieldElement} store={store} />
      {hint && (
        <FormDescription
          name={store.names[name]}
          render={props => (
            <Content
              noSpacing
              {...props}
              className={styles.description}
              size="sm"
              withParser
            >
              {hint}
            </Content>
          )}
          store={store}
        />
      )}
      <FormError
        className={styles.error}
        name={store.names[name]}
        store={store}
      />
    </>
  );
};

export default SelectForm;
